module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-LightItalic-WebS.e2d2b3f2.woff";